import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Button, Tooltip, OverlayTrigger} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import {setUIState} from '../../core/redux/ui'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'

class NewTicketButton extends Component {
    static propTypes = {
    }

    _navigate() {
        const {dispatch, authenticated} = this.props

        if (authenticated.userType == 'callCenterOperator' || authenticated.userType == 'callCenterUser') {
            dispatch(push('/openticket'))
            return
        }
        dispatch(push('/tickets/new'))
    }

    render() {
        const {dispatch, authenticated, _links, ...others} = this.props

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        return _links.find(linkFinder('OpenTicket')) != null && (
            <OverlayTrigger
                placement='left'
                overlay={tooltip(i18n.newTicket)}>
                <Button
                    bsStyle='primary'
                    bsSize='large'
                    onClick={() => this._navigate()}>
                    <Icon icon='ticket' size='md' />
                </Button>
            </OverlayTrigger>
        )
    }
}

NewTicketButton = connect((state) => ({
    authenticated: state.user.authenticated,
    _links: state.ticket._links
}))(NewTicketButton)

export default NewTicketButton


// WEBPACK FOOTER //
// ./lib/ticket/components/NewTicketButton.js